export const Spiner = () => (
  <div
    style={{
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: "100%",
      height: "100%",
    }}
  >
    <div style={{ textAlign: "center", color: "rgba(255,255,255,0.85)" }}>
      <div
        style={{
          width: 48,
          height: 48,
          borderRadius: 24,
          border: "4px solid rgba(255,255,255,0.12)",
          borderTopColor: "#00d4ff",
          margin: "0 auto",
          animation: "spin 1s linear infinite",
        }}
      />
      <div style={{ marginTop: 8 }}>Loading chart…</div>
    </div>
    <style>{`@keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }`}</style>
  </div>
);
